import { useState, useEffect } from "react";
import { BlogPost } from "../types/blogTypes";
import { getBlogPostBySlug } from "../utils/api-communication/RestApiCli";

interface UseBlogDetailReturn {
  blog: BlogPost | null;
  loading: boolean;
  error: string | null;
}

export function useBlogDetail(slug: string): UseBlogDetailReturn {
  const [blog, setBlog] = useState<BlogPost | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!slug) {
      setError("Slug is required");
      setLoading(false);
      return;
    }

    const fetchBlog = async () => {
      setLoading(true);
      setError(null);
      try {
        const response: any = await getBlogPostBySlug(slug);
        if (response) {
          setBlog(response);
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : "Failed to fetch blog post");
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [slug]);

  return { blog, loading, error };
}
